export const LoadingPage = () => {
    return (
        <div className="centeredBody">
            <div className="message">
                <h1 className="loadingEllipsis">Loading</h1>
            </div>
        </div>
    );
};